export default __webpack_public_path__ + "static/media/cool-off.a6ed019d.svg";